
function DNDGallery({card, language, elementStyle, changeSelection, imgWidth = '7'}) {

  const imgs = card.value.map((value, index) => {
    return (
      <li key={`${value.name}_${index}`} className="slide">
        <img
          alt="no image found"
          src={value.languages[language]}
          onError={(e) => (e.currentTarget.style.display = "none")}
          onLoad={(e) => (e.currentTarget.style.display = "")}
          style={{
            width: imgWidth + "%",
            objectFit: "contain"
          }}
        />
      </li>
    );
  })

  return (
    <div
      id="componentContainer"
      data-tour="rpdesigner-step-3"
      style={elementStyle}
      onClick={changeSelection}
    >
      <section className="slider-wrapper">
        <button className="slide-arrow" id="slide-arrow-prev">
          &#8249;
        </button>
        <button className="slide-arrow" id="slide-arrow-next">
          &#8250;
        </button>
        <ul className="slides-container" id="slides-container">
          {imgs}
        </ul>
      </section>
      <input
        readOnly
        id="displayDefault"
        style={{ display: "none" }}
        value={card.displayDefault}
      />
      <input
        readOnly
        id="displaySuccess"
        style={{ display: "none" }}
        value={card.displaySuccess}
      />
      <input
        readOnly
        id="displayError"
        style={{ display: "none" }}
        value={card.displayError}
      />
    </div>
  );
}

export default DNDGallery;